const initialState = () => ({
    list: []
});

const foldersReducer = (state = initialState(), action) => {
    const newState = Object.assign({}, state);
    switch (action.type) {
        case 'FOLDERS_RECEIVED':
            newState.list = action.payload.folders;
            return newState;
        case 'LOGOUT':
            return Object.assign({}, initialState());
        default:
            return state;
    }
};

export default foldersReducer;

